import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { urlUpload } from 'src/app/config/config';
import { DocumentosService } from 'src/app/services/documentos/documentos.service';
import { GenericService } from 'src/app/services/generic/generic.service';
import { UploadService } from 'src/app/services/upload/upload.service';



@Component({
  selector: 'app-upload-documentacion',
  templateUrl: './upload-documentacion.component.html',
  styleUrls: ['./upload-documentacion.component.css']
})
export class UploadDocumentacionComponent implements OnInit {
  
  @Input() categoria = "";
  @Output() cerrarDocumentacion = new EventEmitter();

  public url: string = '';
  public doc_procedimiento: File;
  public doc_anexo: File ;
  public url_doc_procedimiento: string = '';
  public url_doc_anexo: string = '' ;
  public showUploadButton = false;
  public update = false;
  public id = 0;
  public database = 'documentos';
  public anexo_folder = 'documentos/anexos';
  public procedimientos_folder = 'documentos/procedimientos';
  public url_documentos = urlUpload;
  public disable_button = false;

  constructor(
    private genericService: GenericService,
    private fileUploadService: UploadService,
    public messageService: MessageService,
    private documentosService: DocumentosService
  ) { 
     
  }

  ngOnInit() {
    this.listarDocumentos();
    
  }

  listarDocumentos() {
    this.genericService.getNameField('categoria', this.categoria, this.database).toPromise()
    .then( (resp: any) => {
      //console.log('resp getDocumentos', resp);
      if( resp.etiqueta == null || resp.etiqueta.length <= 0) {
        this.update = false;
      }else {
        this.update = true;
        this.categoria = resp.etiqueta[0]['categoria'];
        this.url_doc_anexo = resp.etiqueta[0]['doc_anexo'];
        this.url_doc_procedimiento = resp.etiqueta[0]['doc_procedimiento'];
        this.id = resp.etiqueta[0]['id'];
      }
      this.documentosService.updateTables();
    }).catch( error => {
      console.log('error', error);
      
    })
  }
  cerrarVentanaDocumentacion( event ) {
    this.cerrarDocumentacion.emit(event);
  }

  procedimientoClear( event) {
    this.doc_procedimiento = null;
  }

  procedimientoSelect( event, file: FileUpload ) {
   this.doc_procedimiento = file.files[0];
  }

  anexoClear( event) {
    this.doc_anexo = null;
  }

  anexoSelect( event, file: FileUpload ) {
   this.doc_anexo = file.files[0];
  }

  guardarDocumentacion() {

    let auxDoc = {
      id: this.id,
      categoria: this.categoria,
      doc_anexo: this.url_doc_anexo,
      doc_procedimiento: this.url_doc_procedimiento,
    };
    this.disable_button = true;
    if ( this.update ) {
      this.genericService.update(auxDoc, this.database).toPromise()
      .then( (resp: any) => {
        // console.log('resp', resp);
     
        if (this.doc_anexo == null ) {
          
        } else {
            this.fileUploadService.uploadFilesgeneric(this.doc_anexo, this.id.toString(), this.anexo_folder, this.database, 'doc_anexo' )
            .toPromise()
            .then( anexo => {
              this.messageService.add({ severity: 'success', summary: 'Añadido correctamente', detail: `Registro ${this.database} añadido` });
              this.listarDocumentos();
              this.documentosService.updateTables();
            })
        }
        if (this.doc_procedimiento == null ) {
          
        } else {
            this.fileUploadService.uploadFilesgeneric(this.doc_procedimiento, this.id.toString(), this.procedimientos_folder, this.database, 'doc_procedimiento' )
            .toPromise()
            .then( procedemiento => {
              this.messageService.add({ severity: 'success', summary: 'Añadido correctamente', detail: `Registro ${this.database} añadido` });
              this.listarDocumentos();
            });
            this.documentosService.updateTables();
        }
      }).catch( error => {
        console.log('error', error);
      }).then( () => {
        this.documentosService.updateTables();
        this.listarDocumentos();
      });
      this.disable_button = false;
    } else {
      this.genericService.create(auxDoc, this.database).toPromise()
      .then( (resp: any) => {
        //console.log('resp', resp);
        if (this.doc_anexo == null ) {
          
        } else {
            this.fileUploadService.uploadFilesgeneric(this.doc_anexo, resp.id, this.anexo_folder, this.database, 'doc_anexo' )
            .toPromise()
            .then( anexo => {
              console.log('anexo', anexo);
              
              this.messageService.add({ severity: 'success', summary: 'Añadido correctamente', detail: `Registro ${this.database} añadido` });
              this.listarDocumentos();
              this.documentosService.updateTables();
            }).catch( error => {
              console.log('error anexo', error);
              
            })
        }
        if (this.doc_anexo == null ) {
          
        } else {
            this.fileUploadService.uploadFilesgeneric(this.doc_procedimiento, resp.id, this.procedimientos_folder, this.database, 'doc_procedimiento' )
            .toPromise()
            .then( procedemiento => {
              console.log('procedemiento', procedemiento);
              this.messageService.add({ severity: 'success', summary: 'Añadido correctamente', detail: `Registro ${this.database} añadido` });
              this.documentosService.updateTables();
              this.listarDocumentos();
            }).catch( error => {
              console.log('error proc', error);
              
            })
        }
      }).then( () => {
        this.documentosService.updateTables();
        this.listarDocumentos();
      })
      
      .catch( error => {
        console.log('error', error);
      })
      this.disable_button = false;
    }
  }

  viewDocumentoAnexo() {
     window.open(this.url_documentos + this.anexo_folder +'/'+ this.url_doc_anexo,'_blank');
  }

  viewDocumentoProcedimiento() {
     window.open(this.url_documentos + this.procedimientos_folder +'/'+ this.url_doc_procedimiento,'_blank');
  }

  deleteAnexoDoc() {
    this.fileUploadService.deleteFilesGeneric(this.id.toString(), this.anexo_folder,this.database,'doc_anexo').toPromise()
    .then(( resp ) => {
      //console.log('resp',resp);
      this.messageService.add({ severity: 'success', summary: 'Borrado correctamente', detail: `Registro ${this.database} borrado` });
      this.documentosService.updateTables();
      this.listarDocumentos();
    }).catch( ( error ) => {
      console.log('error', error);
    })
  }

  deleteProcedimientoDoc() {
    this.fileUploadService.deleteFilesGeneric(this.id.toString(), this.procedimientos_folder,this.database,'doc_procedimiento').toPromise()
    .then(( resp ) => {
     // console.log('resp',resp);
     this.messageService.add({ severity: 'success', summary: 'Borrado correctamente', detail: `Registro ${this.database} borrado` });
     this.documentosService.updateTables();
     this.listarDocumentos();
    }).catch( ( error ) => {
      console.log('error', error);
    })
  }

}
